import React, { useEffect, useRef } from 'react';
import Header from '@/components/foundations/header';
import Footer from '@/components/foundations/footer';
import smoothScroller from '@/lib/smoothScroller';
import '@/styles/common.scss';

const Layout: React.FC<{ location: Location }> = ({ children, location }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  // location.hashに変化があれば
  useEffect(() => {
    location.hash && smoothScroller({ to: location.hash });
  }, [location.hash]);

  return (
    <div className="hoge" ref={wrapperRef}>
      <Header />
      <main>
        {React.Children.map(children, (child: string | React.ReactNode) => {
          switch (typeof child) {
            case 'string':
              return child;
            case 'object':
              return React.cloneElement(child as React.ReactElement, { routeRef: wrapperRef });
            default:
              return null;
          }
        })}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
